import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { svgSprite } from '../wrappers';
import { t } from '../../common/components/T';
import uikit from '../../project/uikit/styles';
import { useWidgetTranslates } from '../../common/utils/utils';
import classNames from 'classnames';

const SpeedProgress = ({
    formatted_accumulated,
    formatted_left_to_accumulate,
    target,
    hasPV,
    title,
    styles,
    showAim = true,
    key
}) => {
    const trans = useWidgetTranslates('speedProgress');

    let pers = (hasPV / target) * 100; // вычисляем процент выполения
    if (pers > 100) {
        pers = 100;
    }
    const dasharray = 304; // длина svg
    const endPath = 0; // точка окончания прорисовки svg
    const dashoffset = ((dasharray - endPath) / 100) * (100 - pers) + endPath;
    const radius = 54; // радиус окружности
    const coordinatesProgress = useMemo(() => {
        // set>max ? set = max : '';
        const lengthPath = (128.3 / 100) * pers; // где 128.5-максимальная длина пути , 100 - 100%
        const rotateMark = (255 / 100) * pers; // 255 - максимальный градус оборота маркера-стрелочки
        const s = ((2 * Math.PI) / 180) * lengthPath; // Вычислим угол
        return {
            top: `${44 + radius * Math.sin(s)}px`, // 60 - радиус окружности минус висота врапера маркера-стрелочки
            left: `${45 + radius * Math.cos(s)}px`, // 60 - радиус окружности минус ширина врапера маркера-стрелочки
            transform: `rotateZ(${rotateMark - 4}deg)`
        };
    }, [pers]);

    if (!trans) return null;
    return (
        <div className={styles.speedProgressComponent}>
            <div className={styles.officeWrapSpeedProgress}>
                {(100 / target) * hasPV < 100 ? (
                    <div className={styles.officeSpeedProgressSvg} style={{ top: '9px' }}>
                        {svgSprite('speed-progress-colored', {
                            width: '142px',
                            height: '115px',
                            color1: 'var(--redDarkColor)',
                            color2: 'var(--orangeColor)',
                            color3: 'var(--greenColor)'
                        })}
                    </div>
                ) : (
                    <div className={styles.officeSpeedProgressSvg}>
                        {svgSprite(
                            'speed-progress-done',
                            {
                                width: '175px',
                                height: '143px',
                                color1: 'var(--greenColor)',
                                color2: 'var(--greenGradientLightColor)'
                            },
                            key
                        )}
                    </div>
                )}
                <div style={{ position: 'absolute', top: '23px' }}>
                    {svgSprite('speed-progress-path', {
                        width: '115',
                        height: '91',
                        fill: 'var(--darkColor)',
                        className: styles.officeSpeedProgressPathSvgDone
                    })}
                </div>
                <div style={{ position: 'absolute', top: '23px' }}>
                    {svgSprite(
                        'speed-progress-value',
                        {
                            width: '115',
                            height: '91',
                            stroke: 'var(--greyDeepExtraDarkColor)',
                            className: styles.officeSpeedProgressPathSvgDone
                        },
                        key,
                        [dasharray, dashoffset]
                    )}
                </div>

                <div className={styles.officeSpeedProgressCircle}>
                    <div className={styles.markerSpeedProgress} style={coordinatesProgress}>
                        <div className={styles.markerSpeedProgressArrowWrap}>
                            {svgSprite(
                                'speed-progress-arrow',
                                {
                                    width: '24px',
                                    height: '3px',
                                    fill: 'var(--greyDeepExtraDarkColor)',
                                    className: styles.arrowSpeedProgress
                                },
                                key
                            )}
                        </div>
                    </div>
                </div>
                <div className={styles.startProgress}>
                    <p className={styles.startProgressText}>0</p>
                </div>
                <div className={styles.endProgress}>
                    <p className={styles.endProgressText}>100%</p>
                </div>
                <div className={styles.infoSpeedProgress}>
                    <div className={styles.infoSpeedProgressTitleWrap} style={uikit.title}>
                        <div className={styles.infoSpeedProgressTitle}>
                            <p className={styles.grayTitle}>{title}</p>
                        </div>
                    </div>
                    <div style={uikit.mb2}>
                        <p
                            className={classNames(
                                styles.infoSpeedProgressValue,
                                !((100 / target) * hasPV < 100) && styles.infoSpeedProgressValueDone
                            )}
                            style={(100 / target) * hasPV < 100 ? { color: 'var(--darkColor)' } : {}}
                        >
                            {formatted_accumulated}
                        </p>
                    </div>
                    {(100 / target) * hasPV < 100 && (
                        <div className={styles.infoSpeedProgressPercentWrap}>
                            <p className={styles.infoSpeedProgressPercent}>{Math.round((100 / target) * hasPV)}%</p>
                        </div>
                    )}
                </div>
            </div>
            {showAim ? (
                <div className={styles.quantitySpeedProgress} style={uikit.small}>
                    <p className={styles.quantitySpeedProgressText}>
                        {`${t(
                            'quantitySpeedProgressTextTarget',
                            'Цель',
                            'widget',
                            trans,
                            'speedProgress'
                        )} ${formatted_accumulated}`}
                    </p>
                    {(100 / target) * hasPV < 100 ? (
                        <p className={styles.quantitySpeedProgressText}>
                            {`${t(
                                'quantitySpeedProgressTextMore',
                                'Еще',
                                'widget',
                                trans,
                                'speedProgress'
                            )} ${formatted_left_to_accumulate}`}
                        </p>
                    ) : (
                        <p className={styles.speedProgressDone}>
                            {t('quantitySpeedProgressTextDone', 'Выполнен', 'widget', trans, 'speedProgress')}
                            {svgSprite('check-circle-fill', {
                                className: styles.speedProgressDoneSvg
                            })}
                        </p>
                    )}
                </div>
            ) : (
                <></>
            )}
        </div>
    );
};

SpeedProgress.propTypes = {
    formatted_accumulated: PropTypes.node,
    formatted_left_to_accumulate: PropTypes.node,
    target: PropTypes.number,
    hasPV: PropTypes.number,
    title: PropTypes.node,
    styles: PropTypes.object,
    showAim: PropTypes.bool,
    key: PropTypes.string
};

export default SpeedProgress;
